import { Slot } from '@radix-ui/react-slot';
import { cva } from 'class-variance-authority';
import { forwardRef } from 'react';
import { cn } from '@/lib/utils';

const outerVariants = cva('', {
  variants: {
    variant: {
      primary:
        'w-full border border border-black/10 bg-linear-to-b from-black/70 to-black p-px transition duration-300 ease-in-out',
      secondary: 'w-full border border-black/20 bg-white/50 p-px transition duration-300 ease-in-out',
    },
    size: {
      sm: 'rounded-[6px]',
      default: 'rounded-[12px]',
      lg: 'rounded-[12px]',
    },
  },
  defaultVariants: { variant: 'primary', size: 'default' },
});

const innerVariants = cva('w-full h-full flex items-center justify-center', {
  variants: {
    variant: {
      primary:
        'gap-2 bg-linear-to-b from-neutral-800 to-black text-sm text-white/90 transition duration-300 ease-in-out hover:from-stone-800 hover:to-neutral-800/70 active:from-black active:to-black',
      secondary:
        'gap-2 bg-linear-to-b from-neutral-100/80 to-neutral-200/50 text-sm transition duration-300 ease-in-out hover:from-neutral-200/40 hover:to-neutral-300/60 active:from-neutral-200/60 active:to-neutral-300/70',
    },
    size: {
      sm: 'text-xs rounded-[4px] px-4 py-1',
      default: 'text-sm rounded-[10px] px-4 py-2',
      lg: 'text-base rounded-[10px] px-4 py-2.5',
    },
  },
  defaultVariants: { variant: 'primary', size: 'default' },
});

const TextureButton = forwardRef(
  ({ children, variant = 'primary', size = 'default', asChild = false, className, ...props }, ref) => {
    const Comp = asChild ? Slot : 'button';

    return (
      <Comp className={cn(outerVariants({ variant, size }), className)} ref={ref} {...props}>
        <div className={cn(innerVariants({ variant, size }))}>{children}</div>
      </Comp>
    );
  },
);

TextureButton.displayName = 'TextureButton';

export { TextureButton };
